"use client"

import { cn } from "@/utils/classnames"
import { useState, forwardRef } from "react"
import { Text } from "./Text"

interface BorderedInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasBorder?: boolean
}

export const BorderedInput = forwardRef<HTMLInputElement, BorderedInputProps>(
  ({ className, hasBorder = true, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false)

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(true)
      rest.onFocus?.(e)
    }

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false)
      rest.onBlur?.(e)
    }

    return (
      <input
        ref={ref}
        className={cn(
          "resize-none rounded-md border bg-transparent p-4 py-3 outline-none ring-transparent text-body1-md placeholder:text-fg-3 focus:outline-none focus-visible:outline-none lg:text-body1-lg",
          isFocused ? "border-primary-3" : "border-bg-3",
          className
        )}
        {...rest}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    )
  }
)

BorderedInput.displayName = "BorderedInput"
